import type { FaireProductEntity } from "../../entity_types/product";

export const p_j7jdtsamhk: FaireProductEntity = {
  token: "p_j7jdtsamhk",
  type: "product",
  name: "Be Kind Of A B Hat",
  brandToken: "b_tacvsj4rz9",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/144eb7d71e11bee987760bafd69934e86768d036b3a4b81800ce186afa2be7d0.png",
  galleryImageUrls: [],
  priceDollars: 24.94,
  description:
    "The 'Be Kind' Hat from 9 Priscilla Way is a unique addition to your accessories. This unisex trucker hat comes with a striking embroidered detail that adds a touch of personality to any outfit. 9 Priscilla Way has crafted this hat with care and creativity. Wear it knowing that each piece from our brand carries a story of personal expression.",
  tags: [],
  msrpDollars: 49.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:52.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
